module.exports = __webpack_public_path__ + "static/img/bg-llamado-accion.c689224.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg-llamado-accion.webp
// module id = 9ZPH
// module chunks = 0